import React, { FormEvent, memo } from 'react';
import { Cell, FormControl, Row } from '@dexma/ui-components';
import { StyledColorPicker } from 'adapter/in/common/components/ColorPicker/style';

type ColorPickerEvent = {
    hex: string;
};

export type FormInputColorPickerProps = {
    dataTestId: string;
    enabled?: boolean;
    error: boolean;
    errorMessage?: string;
    initialColor: string;
    label: string;
    name: string;
    isLoading: boolean;
    showInput?: boolean;
    onChange: (text: string) => void;
    value: string;
};
const FormColorPicker = memo((props: FormInputColorPickerProps) => {
    const { label, enabled, error, errorMessage, name, initialColor, isLoading, dataTestId, showInput, onChange, value } = props;

    const handleChange = (e: ColorPickerEvent) => {
        onChange(e.hex);
    };

    const handleChangeInput = (event: FormEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value);
    };

    return (
        <StyledColorPicker $error={error} $showInput={showInput}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <FormControl
                control='ColorPicker'
                showInput={showInput}
                data-testid={dataTestId}
                disabled={!enabled}
                isLoading={isLoading}
                initialColor={initialColor}
                name={name}
                onChangePicker={handleChange}
                onChangeInput={handleChangeInput}
                value={value}
            />
            {error && <div className='error'>{errorMessage}</div>}
        </StyledColorPicker>
    );
});

export default FormColorPicker;
